:host {
  --aha-search-field--border-color: var(--theme-primary-border);
  --aha-search-field--icon-color: var(--theme-secondary-text);
  --aha-search-field--background-color: var(--theme-input-background);

  display: inline-flex;
  align-items: center;
  box-shadow: 0 0 0 1px var(--aha-search-field--border-color);
  border-radius: 30em;
  transition: box-shadow linear 0.2s;
  font-size: 0.75rem;
  height: 30px;
  width: 220px;
  min-width: 76px;
  background-color: var(--aha-search-field--background-color);
}

:host(:focus-within) {
  box-shadow: var(--box-shadow-focus-ring);
  --aha-search-field--icon-color: var(--theme-primary-text);
}

#cancel-icons {
  display: inline-grid;
}
button {
  all: unset;
  cursor: pointer;
  color: var(--theme-tertiary-text);
  display: inline-grid;
  grid-template-columns: 1fr;
  grid-template-rows: 1fr;
  justify-items: center;
  align-items: center;
  align-self: stretch;
  aspect-ratio: 1;
  height: 100%;
}
button fa-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
}
button:where(:hover, :focus-visible) {
  color: var(--theme-primary-text);
}

:host(:not([loading])) aha-spinner {
  display: none;
}

#magnifying-glass,
::slotted(*) {
  align-self: center;
  color: var(--aha-search-field--icon-color);
  padding-left: var(--spacer-2);
  padding-right: var(--spacer-2);
}

input[type='search']:placeholder-shown + button {
  display: none;
}

input[type='search'] {
  appearance: none;
  min-width: 20px;
  font-size: inherit;
  font-family: inherit;
  border: none;
  line-height: inherit;
  outline: none;
  flex: 1 1;
  background-color: transparent;
  color: var(--theme-primary-text);

  &[placeholder] {
    text-overflow: ellipsis;
  }
}
input[type='search']::-webkit-search-cancel-button {
  appearance: none;
}

input::placeholder {
  color: var(--theme-tertiary-text);
}
